import { ExplorerNavBar } from "client/src/components/NavBar/ExplorerNavBar";
import { isYourBenefitsExplorer } from "client/src/utils/benefits-explorer";
import { RouteData } from "shared/config/routeData";

type ExplorerNavPageProps = {
  pageKey: string;
};

export const ExplorerNavPage = ({ pageKey }: ExplorerNavPageProps) => {
  return (
    <ExplorerNavBar
      personalBenefitsPlanLink={
        isYourBenefitsExplorer()
          ? RouteData.personalBenefitsPlan.getPath(pageKey)
          : RouteData.personalBenefitsPlanInternal.getPath(pageKey)
      }
      pageKey={pageKey}
    />
  );
};
